import { SegmentEvent } from '@/integrations/segment/SegmentEvent';
import { OnboardingWelcomeModalViewedEventTracking } from '@/modules/auth/models/segmentevents/OnboardingWelcomeModalViewedEventTracking';

export class OnboardingWelcomeModalCompletedEventTracking extends OnboardingWelcomeModalViewedEventTracking {
  static eventName: SegmentEvent = SegmentEvent.ONBOARDING_WELCOME_MODAL_COMPLETED;
}
